export default "__VITE_ASSET__CMK2bn_S__"